module.exports = __webpack_public_path__ + "zvetseni-prsou_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_7_after.jpg
// module id = 1367
// module chunks = 0